import {playSvg as Icon__small__playSvg} from '../Icon__small/Icon__small--play.js'

export var play = {
  name: 'play',
  category: 'icon',
  colorable: true,
  svg: Icon__small__playSvg,
};
